import React from 'react';
import { UploadPicture, Plus } from '@icon-park/react';
import './styles/RelatedLinks.css';

function RelatedLinks({ data, onUpdate }) {
  const defaultLinks = [
    { enabled: true, icon: '', name: '官方网站', url: '', order: 1 }
  ];

  const links = data.links || defaultLinks;
  const layout = data.layout || 'grid';
  const cs = data.cardStyle || {};
  const logoSize = Number(data.logoSize || (layout === 'vertical-card' ? 72 : 36));

  const handleLinkChange = (index, field, value) => {
    const newLinks = [...links];
    newLinks[index][field] = value;
    onUpdate({ ...data, links: newLinks });
  };

  const handleAddLink = () => {
    const newLinks = [...links];
    newLinks.push({ 
      enabled: true, 
      icon: '', 
      name: '', 
      url: 'http://', 
      order: links.length + 1 
    });
    onUpdate({ ...data, links: newLinks });
  };

  const handleIconUpload = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        handleLinkChange(index, 'icon', e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="related-links-container">
      <h3 className="template-title">相关链接</h3>

      {/* 布局设置区域 */}
      <div className="config-section">
        <div className="config-section-header">
          <span className="config-section-title">布局设置</span>
        </div>
        <div className="config-section-body">
          <div className="config-row">
            <label className="config-label">布局方式</label>
            <select 
              className="config-select"
              value={layout} 
              onChange={(e) => onUpdate({ ...data, layout: e.target.value })}
            >
              <option value="grid">网格</option>
              <option value="vertical-card">纵向卡片</option>
              <option value="horizontal-row">横向行</option>
            </select>
          </div>
          <div className="config-row">
            <label className="config-label">Logo尺寸</label>
            <div className="config-input-group">
              <input 
                type="number" 
                className="config-input-number"
                min="16" 
                max="128" 
                value={logoSize} 
                onChange={(e) => onUpdate({ ...data, logoSize: Number(e.target.value) })} 
              />
              <span className="config-unit">px</span>
            </div>
          </div>
        </div>
      </div>

      {/* 样式设置区域 */}
      <div className="config-section">
        <div className="config-section-header">
          <span className="config-section-title">样式设置</span>
        </div>
        <div className="config-section-body">
          <div className="config-grid">
            <div className="config-item">
              <label className="config-label-small">卡片背景</label>
              <div className="color-input-wrapper">
                <input 
                  type="color" 
                  className="config-color"
                  value={cs.bgColor || '#ffffff'} 
                  onChange={(e) => onUpdate({ ...data, cardStyle: { ...cs, bgColor: e.target.value } })} 
                />
                <span className="color-value">{cs.bgColor || '#ffffff'}</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">文字颜色</label>
              <div className="color-input-wrapper">
                <input 
                  type="color" 
                  className="config-color"
                  value={cs.textColor || '#202124'} 
                  onChange={(e) => onUpdate({ ...data, cardStyle: { ...cs, textColor: e.target.value } })} 
                />
                <span className="color-value">{cs.textColor || '#202124'}</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">边框色</label>
              <div className="color-input-wrapper">
                <input 
                  type="color" 
                  className="config-color"
                  value={cs.borderColor || '#e8eaed'} 
                  onChange={(e) => onUpdate({ ...data, cardStyle: { ...cs, borderColor: e.target.value } })} 
                />
                <span className="color-value">{cs.borderColor || '#e8eaed'}</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">边框宽</label>
              <div className="config-input-group">
                <input 
                  type="number" 
                  className="config-input-number"
                  min="0" 
                  max="8" 
                  value={cs.borderWidth ?? 1} 
                  onChange={(e) => onUpdate({ ...data, cardStyle: { ...cs, borderWidth: Number(e.target.value) } })} 
                />
                <span className="config-unit">px</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">圆角</label>
              <div className="config-input-group">
                <input 
                  type="number" 
                  className="config-input-number"
                  min="0" 
                  max="24" 
                  value={cs.radius ?? 12} 
                  onChange={(e) => onUpdate({ ...data, cardStyle: { ...cs, radius: Number(e.target.value) } })} 
                />
                <span className="config-unit">px</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-checkbox-label">
                <input 
                  type="checkbox" 
                  className="config-checkbox"
                  checked={cs.shadow !== false} 
                  onChange={(e) => onUpdate({ ...data, cardStyle: { ...cs, shadow: e.target.checked } })} 
                />
                <span>阴影效果</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* 链接列表区域 */}
      <div className="links-section">
        <div className="links-section-header">
          <span className="links-section-title">链接列表</span>
          <span className="links-count">共 {links.length} 个链接</span>
        </div>
        <div className="links-table">
          <div className="links-table-header">
            <div className="col-checkbox"></div>
            <div className="col-icon">示例图片</div>
            <div className="col-name">示例名称</div>
            <div className="col-url">链接</div>
            <div className="col-order">排序</div>
          </div>

        {links.map((link, index) => (
          <div key={index} className="links-table-row">
            <div className="col-checkbox">
              <input
                type="checkbox"
                checked={link.enabled}
                onChange={(e) => handleLinkChange(index, 'enabled', e.target.checked)}
                className="link-checkbox"
              />
            </div>
            <div className="col-icon">
              <input
                type="file"
                id={`link-icon-${index}`}
                accept="image/*"
                onChange={(e) => handleIconUpload(index, e)}
                style={{ display: 'none' }}
              />
              <label htmlFor={`link-icon-${index}`} className="icon-upload-label">
                {link.icon ? (
                  typeof link.icon === 'string' && link.icon.startsWith('data:') ? (
                    <img src={link.icon} alt="图标" className="link-icon-img" />
                  ) : (
                    <span className="link-icon-emoji">{link.icon}</span>
                  )
                ) : (
                  <span className="upload-icon-placeholder">
                    <UploadPicture theme="outline" size={18} fill="#333" strokeWidth={3} />
                  </span>
                )}
              </label>
            </div>
            <div className="col-name">
              <input
                type="text"
                className="link-input"
                value={link.name}
                onChange={(e) => handleLinkChange(index, 'name', e.target.value)}
                placeholder="链接名称"
              />
            </div>
            <div className="col-url">
              <input
                type="text"
                className="link-input"
                value={link.url}
                onChange={(e) => handleLinkChange(index, 'url', e.target.value)}
                placeholder="http://"
              />
            </div>
            <div className="col-order">
              <input
                type="number"
                className="order-input"
                value={link.order}
                onChange={(e) => handleLinkChange(index, 'order', e.target.value)}
                min="1"
              />
            </div>
          </div>
        ))}
        </div>
      </div>

      <button className="add-link-btn" onClick={handleAddLink}>
        <span className="add-icon"><Plus theme="outline" size={18} fill="#333" strokeWidth={3} /></span>
        <span>添加链接</span>
      </button>
    </div>
  );
}

export default RelatedLinks;
